import styled from 'styled-components';

export const StyledTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg2[0]};
  box-shadow: 0 3px 16px -8px rgb(19 32 57 / 40%);
  border-radius: ${({ theme }): string => theme.spacers!.spacer02};
  background: ${({ theme }): string => theme.admanColors!.gray.dark.bg3[1]};
  text-align: center;
  color: ${({ theme }): string => theme.colors!.colorWhite};
`;

export const StyledTooltipTitle = styled.div`
  padding: ${({ theme }): string => theme.spacers!.spacer02} ${({ theme }): string => theme.spacers!.spacer04};
  border-bottom: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg0[3]};
  width: 100%;
  display: flex;
  font-family: InspireTWDC;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
`;

export const StyledContentTooltip = styled.div`
  font-family: InspireTWDC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  text-align: left;
  display: flex;
  white-space: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }): string => theme.spacers!.spacer02} ${({ theme }): string => theme.spacers!.spacer04};

  div {
    white-space: nowrap;
  }
`;

export const StyledItemName = styled.div`
  display: flex;
  align-items: center;
  padding-right: ${({ theme }): string => theme.spacers!.spacer02};
`;
